import React, { useEffect } from 'react';
import { useNavigation } from '../../Handler/NavigationHandler';
import PrimaryButton from '../Buttons/PrimaryButton';
import Text from '../Text';
import useDocTitle from '../../Handler/DocTitleHandler';

/**
 * Arthur-Fischer-Erfinderpreis Quick Check App
 *
 * Step A
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const StepInitial = props => {
  const { resetDocTitle } = useDocTitle();
  const { handleStepClick, getNextStep } = useNavigation();

  // Changes the doc title
  useEffect(() => {
    resetDocTitle();
  }, []);

  // Simple button handler
  const handleButtonClick = (e) => {
    e.preventDefault();
    handleStepClick(getNextStep());
  };

  return (<>
    <img className="image image--quickcheck-logo" alt="Logo" src="/dest/images/afp/afp-logo-quickcheck.svg" />

    <h1 className="headline headline--1">Quick Check</h1>

    <div className="text text--afp-quickcheck">
      <Text path="steps.initial.text">Passt der Arthur Fischer Erfinderpreis zu mir?</Text>
    </div>

    <PrimaryButton onClick={handleButtonClick}>Los gehts</PrimaryButton>
  </>);
}

export default StepInitial;
